import { useId } from "react";

import BaseButton from "@/components_v2/Button/BaseButton";
import {
  BUTTON_SIZES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";
import { FilterGroupProps } from "@/features/certifications/community-flags/types";

import "../styles.css";

const FilterGroup = <T extends string>({
  label,
  options,
  value,
  getLabel,
  onChange,
}: FilterGroupProps<T>) => {
  const labelId = useId();

  return (
    <div className="flex flex-wrap items-center gap-200">
      <span id={labelId} className="flag-type-label body-s-regular">
        {label}
      </span>

      <div
        role="group"
        aria-labelledby={labelId}
        className="flex flex-wrap gap-100"
      >
        {options.map((option) => (
          <BaseButton
            key={option}
            size={BUTTON_SIZES.SMALL}
            variant={
              option === value
                ? BUTTON_VARIANTS.PRIMARY
                : BUTTON_VARIANTS.TERTIARY
            }
            ariaPressed={option === value}
            onClick={() => onChange(option)}
          >
            {getLabel(option)}
          </BaseButton>
        ))}
      </div>
    </div>
  );
};

export default FilterGroup;
